module.exports = __webpack_public_path__ + "img/image7.ac5cffa0.png";